<script lang="ts" setup>
import { CheckCircleIcon } from 'lucide-vue-next';
import { onMounted, ref } from 'vue';

import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';
import { TransitionFade } from '@nzyme/vue-transitions/TransitionFade.jsx';
import { vScrollIntoView } from '@nzyme/vue-utils/directives/vScrollIntoView.js';
import type { PatientProfile } from '@sigma/common/patient/PatientProfile.js';
import InfoBox from '@sigma/ui/InfoBox.vue';
import Loader from '@sigma/ui/Loader.vue';
import PatientProfileForm from '@sigma/ui/patients/PatientProfileForm.vue';

import * as l from './ProfilePage.loc.js';
import { useProfile } from './useProfile.js';

const t = useTranslate();
const { getProfile, updateProfile } = useProfile();
const profile = ref<PatientProfile>();
const saved = ref(false);

onMounted(async () => {
  const result = await getProfile();
  profile.value = result.profile;
});
</script>

<template>
  <div :class="css.page">
    <TransitionFade>
      <PatientProfileForm
        v-if="profile"
        :profile="profile"
        :submit="updateProfile"
        @saved="saved = true"
      >
        <InfoBox
          v-if="saved"
          v-scroll-into-view="{ options: { behavior: 'smooth', block: 'center' } }"
          :icon="CheckCircleIcon"
          color="green"
          border
        >
          {{ t(l.successMessage) }}
        </InfoBox>
      </PatientProfileForm>

      <Loader
        v-else
        :class="css.loader"
      />
    </TransitionFade>
  </div>
</template>

<style lang="scss" module="css">
.page {
  padding-top: $main-header-height;
}

.loader {
  margin: $spacing-32;
  align-self: center;
  color: $color-blue-600;
  width: 50px;
  height: 50px;
}
</style>
